import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ModalService } from 'src/app/shared/components/modal/modal.service';

@Component({
	selector: 'app-confirm-modal',
	templateUrl: './confirm.modal.component.html'
})
export class ConfirmModalComponent implements OnInit {
	title = '';
	message = '';
	buttonText = 'Confirm';
	buttonClass = 'bg-red-700';
	@ViewChild('modalComponent') modal: | ModalComponent<ConfirmModalComponent> | undefined;

	callback = () => { };

	constructor(
		private modalService: ModalService<ConfirmModalComponent>,
	) { }

	ngOnInit(): void {
		const data = this.modalService.getData();
		if (data) {
			this.title = data.title;
			this.message = data.message;
			this.buttonClass = data.buttonClass || 'bg-red-700';
			this.buttonText = data.buttonText || 'Confirm';
			this.callback = data.callback;
		}
	}

	async submit(): Promise<void> {
		this.callback();
		await this.modal?.close();
	}

	async close(): Promise<void> {
		await this.modal?.close();
	}
}
